import React, {Dispatch, SetStateAction} from "react";
// import ArrowRight from "../../assets/icons/ArrowRight";
import "./styles.scss";
import ArrowRight from "../../assets/icons/ArrowRight";

interface ITitleSection {
    title: any;
    setIsDescriptionModalOpen?: Dispatch<SetStateAction<boolean>>;
}

const TitleSection: React.FC<ITitleSection> = ({title, setIsDescriptionModalOpen}) => {
    const isMobile = window.innerWidth <= 600;

    const handleDescriptionModalOpen = () => {
        if (!setIsDescriptionModalOpen) {
            return;
        }

        setIsDescriptionModalOpen(true);
    };

    return (
        <div className="title-section">
            <div className="title">
                <p>{title}</p>
            </div>
            <button
                type="button"
                onClick={handleDescriptionModalOpen}
                className={`arrow-btn icon ${isMobile ? "icon-mobile" : ""}`}
            >
                <ArrowRight/>
            </button>
        </div>
    );
};

export default TitleSection;
